import { render, staticRenderFns } from "./ButtonFixedAction.vue?vue&type=template&id=484e97c6&"
import script from "./ButtonFixedAction.vue?vue&type=script&lang=js&"
export * from "./ButtonFixedAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports